import React, { useEffect, useMemo, useState } from 'react';
import styles from './SearchBar.module.css';
import { SearchIcon, CloseIcon } from './Icons';

const SearchBar = ({ onSearch, placeholder = "搜索...", initialValue = '' }) => {
  const normalizedInitial = useMemo(() => {
    return typeof initialValue === 'string' ? initialValue : '';
  }, [initialValue]);

  const [searchTerm, setSearchTerm] = useState(normalizedInitial);

  useEffect(() => {
    setSearchTerm(normalizedInitial);
  }, [normalizedInitial]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    // 实时搜索（可选）
    if (value.length === 0) {
      onSearch('');
    }
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <form className={styles.searchBar} onSubmit={handleSubmit}>
      <div className={styles.searchInputContainer}>
        <input
          type="text"
          className={styles.searchInput}
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleChange}
        />
        
        {searchTerm && (
          <button
            type="button"
            className={styles.searchClearBtn}
            onClick={handleClear}
          >
            <CloseIcon size={16} />
          </button>
        )}
        
        <button
          type="submit"
          className={styles.searchSubmitBtn}
        >
          <SearchIcon size={18} />
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
